export default {
  startsOnNewPage: 'Zacznij na nowej stronie',
};
